export default "__VITE_ASSET__64d5f0c7__"